import { render, staticRenderFns } from "./BSection.vue?vue&type=template&id=0a918c5c&"
import script from "./BSection.vue?vue&type=script&lang=ts&"
export * from "./BSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports